import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";


import Developing_AR_Games from '../../../assets/Services/AR_game_dev/Developing_AR_Games.png'

import Advanced_AR1 from '../../../assets/Services/AR_game_dev/Our_End-to-End_AR/Advanced_AR-1.svg'
import Advanced_AR from '../../../assets/Services/AR_game_dev/Our_End-to-End_AR/Advanced_AR.svg'
import Custom_AR_Game from '../../../assets/Services/AR_game_dev/Our_End-to-End_AR/Custom_AR_Game.svg'
import EndtoEnd_Dev from '../../../assets/Services/AR_game_dev/Our_End-to-End_AR/End-to-End_Dev.svg'
import Strategic_AR from '../../../assets/Services/AR_game_dev/Our_End-to-End_AR/Strategic_AR.svg'

import Maskgroup1 from '../../../assets/Services/AR_game_dev/Voice_of_Success/Maskgroup-1.png'
import Maskgroup2 from '../../../assets/Services/AR_game_dev/Voice_of_Success/Maskgroup-2.png'
import Maskgroup3 from '../../../assets/Services/AR_game_dev/Voice_of_Success/Maskgroup.png'

import D_asset from '../../../assets/Services/AR_game_dev/AR_Game_Dev/3D_asset.png'
import Ideation from '../../../assets/Services/AR_game_dev/AR_Game_Dev/Ideation&project.png'
import Integration_of_aug from '../../../assets/Services/AR_game_dev/AR_Game_Dev/Integration_of_aug.png'
import Integration_of_aug1 from '../../../assets/Services/AR_game_dev/AR_Game_Dev/Integration_of_aug.png'

import Deployment_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Deployment_&_Maintenance.svg'
import Design_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Design_&_Prototyping.svg'
import GameDevelopment from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg'
import Requirement_Analysis from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Requirement_Analysis.svg'
import Testing_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Testing_&_Quality.svg'

import Arcade_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png'
import Bingo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png'
import Board_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png'
import Ludo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png'
import Rummy_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png'
import Poker_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png'
import Casino_Game_Development from '../../../assets/Services/Board_game_Dev/Casino_Game_Development.png'


import Access_to_Distinguished_Expertise from '../../../assets/Services/Board_game_Dev/Exp_raiden/Access_to_Distinguished_Expertise.svg'
import Advanced_Technology_Implementation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Advanced_Technology_Implementation.svg'
import Complete_regional_adaptation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Complete_regional_adaptation.svg'
import Expert_Consultation_on_Strategic_Issues from '../../../assets/Services/Board_game_Dev/Exp_raiden/Expert_Consultation_on_Strategic_Issues.svg'
import Pioneering_Game from '../../../assets/Services/Board_game_Dev/Exp_raiden/Pioneering_Game-play_Innovation.svg'

import icon1 from '../../../assets/Services/Game_page/AR/icon1.png'
import icon2 from '../../../assets/Services/Game_page/AR/icon2.png'
import icon3 from '../../../assets/Services/Game_page/AR/main.png'
import FaqHome from "../../../components/faq/FaqHome";
import Contact from "../features/miscellaneous/contact";

const ARDevelopmentGame = () => {
  const cards = [
    {
      title: "Ideation and Project Structuring  ",
      desc: "The first step involves more than just brainstorming; it involves systematically transforming disjointed ideas into feasible frameworks. We begin by establishing clear goals, separating essential elements, and creating a design architecture that not only encourages but also propels innovation. This is where accuracy is essential, not optional.",
      img:Ideation ,
    },
    {
      title: "Integration of Augmented Reality  ",
      desc: "Raiden Labs exhibits a high level of expertise in implementing AR, seamlessly fusing digital and real-world content. Using cutting-edge methodologies and advanced toolkits, our AR solutions are designed for scalability across verticals like gaming, retail, and education, guaranteeing practical utility.",
      img: Integration_of_aug,
    },
    {
      title: "3D Asset Production  ",
      desc: "Raiden takes great pride in creating 3D assets. We build intricate models that are designed for interaction and realism, including characters, props, and entire ecosystems. The assets created for augmented reality games, simulations, and other interactive platforms respond accurately when animation pipelines are improved.",
      img: D_asset,
    },
    {
      title: "Strategic Collaborations  ",
      desc: "Raiden Labs doesn’t operate in a vacuum. We collaborate with top tech partners, leveraging outside knowledge and cutting-edge solutions to improve project results. This collaborative approach is more than just networking in a competitive setting; it's about maintaining technical superiority and consistently delivering best-in-class results.",
      img: Integration_of_aug1,
    },
    // {
    //   title: "Cross-platform support",
    //   desc: " Play on all devices with ease, from smartphones and tablets to web browsers, all while your progress and gains are saved through the cloud",
    //   img: ,
    // },
  ];

  const pokerdevcompany2 = [
    {
      title: "  Pioneering Game-play Innovation ",
      icon:Pioneering_Game ,
      desc: "Raiden prefers uniqueness in creativity when it comes to game design. We actively work to add interesting features and innovative mechanics. This dedication to uniqueness sets our product apart and improves the overall gaming experience, encouraging long-term user involvement.   ",
    },
    {
      title: "  Advanced Technology Implementation ",
      icon:Advanced_Technology_Implementation ,
      desc: " We take advantage of modern technological innovations, like safe digital asset management, innovative gaming capabilities, and dependable, scalable real-time infrastructure, to ensure peak performance and future adaptability.  ",
    },
    {
      title: "  Complete regional adaptation ",
      icon: Complete_regional_adaptation,
      desc: "Our approach combines subtle localization—regionally relevant payment methods, culturally sensitive design, and extensive multilingual support—to make sure your game has a significant impact on a wide range of international player communities.   ",
    },
    {
      title: "Expert Consultation on Strategic Issues   ",
      icon: Expert_Consultation_on_Strategic_Issues,
      desc: "As the project progresses from conception to market launch, we offer crucial strategic direction. Our skilled consultants make sure your project complies with current industry norms and is positioned to optimize its competitiveness.   ",
    },
    {
      title: "  Access to Distinguished Expertise ",
      icon:Access_to_Distinguished_Expertise ,
      desc: "Our professionals can produce a polished, reliable, and market-ready unity game with accuracy and efficiency because they have a wealth of knowledge and specialized skills.   ",
    },
  ];

 const pokerdevcompany = [
    {
      title: " Requirement Analysis & Planning",
      icon: Requirement_Analysis  ,
      desc: "We start by determining client requirements, collecting needs, and outlining project scope. Our professionals ensure a tailored Ludo game that reflects your brand image, audience desires, and incorporates features such as RNG and multiplayer support.",
    },
    {
      title: " Design & Prototyping",
      icon: Design_,
      desc: "Our designers make wireframes and interactive prototypes based on a user friendly interface. We provide responsive designs that can be used across  multiple device, from mobile to web, with a consistent experience that includes optimized ludo game mechanics and intuitive visuals.",
    },
    {
      title: " Development & Integration",
      icon: GameDevelopment,
      desc: "Our team of developers utilizes state-of-the-art technologies to give your Ludo game an end-to-end solution. We create features like advanced real-time multiplayer support, chat, a secure payment gateway, and high-quality graphics that provide a better gaming experience to users.",
    },
    {
      title: " Deployment & Maintenance",
      icon:   Deployment_,
      desc: "After successful testing, we deploy the Ludo game across platforms and provide maintenance support. Our support team gives timely updates, bug fixes, and feature enhancements to keep the game fresh, relevant, and engaging for players over time.",
    },
    {
      title: " Testing & Quality Assurance",
      icon: Testing_,
      desc: "Stringent testing and QA processes are used to provide bug-free performance. We perform functional, usability, and security testing for uninterrupted gameplay, authentic dice rolling mechanics, and a secure online environment. All tests ensure the integrity and fairness of the Ludo game.",
    },
  ];


  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon:Arcade_Game_Development ,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Casino Game Development  ",
      icon:Casino_Game_Development ,
      desc: " Deliver immersive casino classics—from slots to roulette and blackjack—integrated with secure wallets, tournament systems, live dealer support, and multilingual functionality, all within a compliance-ready framework.",
      link: "/casino-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon:Ludo_Game_Development ,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon:Rummy_Game_Development ,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
 
  ];

  const custom = [
    {
      icon:Custom_AR_Game ,
      title: "Custom AR Game Development  ",
      desc: "Our specialty is developing original augmented reality games from start to finish. We take client ideas and turn them into fun, interactive games, no matter how complicated. Our objective is to use state-of-the-art augmented reality techniques and specialized technical solutions to transform digital entertainment in this new medium.",
    },
    {
      icon: Advanced_AR ,
      title: "Advanced AR Visuals   ",
      desc: "Modern AR technology is combined with classic game design concepts by our team of exceptionally talented artists. The outcome is visually stunning settings and materials that greatly improve user immersion. Creating visually stunning and dynamic images that connect virtual and physical worlds is still our main goal.",
    },
    {
      icon: EndtoEnd_Dev,
      title: "End-to-End Development Pipeline",
      desc: "Raiden Labs offers a full production pipeline, managing all stages of the creation of augmented reality games, from conception and design to strong engineering, exacting quality control, and smooth launch. In order to guarantee optimal performance and user satisfaction, our procedures are tailored for AR-specific requirements, such as spatial mapping and real-world user interaction.",
    },
    {
      icon:Strategic_AR ,
      title: "Strategic AR Game Design   ",
      desc: "When designing AR games, we take a methodical, research-based approach. We aim to provide experiences that are not only captivating but also inventive and unforgettable by meticulously designing interactive features, user interface components, and gameplay mechanics. Our aim is to make every AR game distinctive through creativity and careful planning, providing players with an unforgettable experience.",
    },
  ];

  const technologies = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Frontend",
      desc: "Swift",
      desc2: " Flutter",
      desc3: " React Native",
    },

    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Backend ",
      desc: " Node.js",
      desc2: " Python",
      desc3: " .NET Core",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Databases  ",
      desc: "PostgreSQL ",
      desc2: " MongoDB",
      desc3: " Firebase",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Cloud & Hosting  ",
      desc: " AWS",
      desc2: " Google Cloud",
      desc3: " Azure",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  APIs & Integrations",
      desc: " GraphQL",
      desc2: " SOAP",
      desc3: "Twilio ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Testing Tools ",
      desc: " Appium",
      desc2: " Selenium",
      desc3: " Anti-Fraud System",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "DevOps & CI/CD  ",
      desc: " GitLab CI/CD",
      desc2: " Jenkins",
      desc3: " Docker",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Analytics & Monitoring",
      desc: " Google Analytics",
      desc2: " Firebase Analytics",
      desc3: " Sentry",
    },
  ];

  const card = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "mobile",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "PC ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "TABLET ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "CONSOLE",
    },
  ];

  const clientexp = [
    {
      icon: Maskgroup1,
      name: "Sarah Chen ",

      desc: "Raiden Labs delivered outstanding results in visual design. The 3D assets and AR game environments showed impressive realism, frequently mentioned by players for their immersive quality. The development team effectively took our core concepts and translated them into a detailed, interactive digital space.",
    },
    {
      icon:Maskgroup2 ,
      name: "David Lee ",
      undername: " ",
      desc: "Choosing Raiden Labs as our development partner was instrumental for our AR game’s market success. Their expertise in mobile optimization ensured stable performance and accessibility across devices, supporting a smooth global launch. The user interface maintained high consistency and usability on all supported platforms.",
    },
    {
      icon: Maskgroup3,
      name: "Maria Rodriguez",
      undername: "  ",
      desc: "Raiden Labs’ implementation of multiplayer infrastructure was a significant technical achievement. Their solution turned our AR title into a dynamic, interactive social platform, resulting in increased user engagement and strong community retention. The team’s ability to construct robust, seamless interactive systems stands out as a key strength.",
    },
  ];

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">AR Game Development</h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              A significant niche has been established by Raiden Labs in the
              gaming industry. Our team constantly creates immersive settings,
              achieving a level of visual fidelity that, to be honest, verges on
              unreal. Our method focuses on maximizing the player's experience—it’s not just about visuals. We maintain a laser-like focus on what really matters: engaging, memorable, and technically impressive gameplay—rather than overblown marketing jargon.  You can
              try to poke holes, but the results kind of speak for themselves.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
        <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mb-3">
            <img src={icon3} style={{ width: "78%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Developing AR Games and Innovating Excellence
            </h2>
            <p className="mt-4  h1-para" >
              Raiden is a well-known figure in the game development industry,
              having spent over ten years developing innovative augmented
              reality product concepts. Utilizing our extensive experience, we
              offer creative, customized augmented reality solutions for
              smartphones and smart glasses. We prioritize features that are
              focused on the user, strong security protocols, and an intuitive
              user interface. Additionally, we employ the most recent augmented
              reality technologies to enhance sustained user engagement.
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                We develop innovative features
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Easily deal in various currencies
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Favors equitable play
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">AR Game Development Services</h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden has been at the forefront of the game development industry,
          continuously producing immersive gaming environments that use unique
          technologies and provide entertaining activities.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Our End-to-End AR Game Development Services
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            As a leading game development company, we create games that support
            all platforms, and we integrate games with blockchain technology
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                Engage in Virtual Game Universe with AR Game Development
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Raiden's expertise in AR game development will provide you with
                a realistic and captivating gaming experience.{" "}
              </p>
              <Link to="/request-quote">
              <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                Schedule a demo call
              </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
           Raiden’s Advanced Tech and Flawless AR
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
          Raiden Labs integrates a skilled tech stack that supports compliance to deliver a distinctive and cutting-edge VR gameplay experience.
          </p>
          <CoreComponent32 technologies={technologies} />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal AR: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your AR app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37 card={card} />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Seeking AR developers
              </h2>
             <p className="h1-para text-white  lh-base" style={{ opacity: 0.6 }}>
                we guarantee gamification at its best and strong data security.
                Engage expert ludo developers now.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={Developing_AR_Games} alt=" " style={{width:'',height:200}} />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Experience Raiden’s AR Game Development{" "}
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and  industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-base">
          The Development Process of Our AR Games
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We’re dedicated to pushing the boundaries of technology—always looking
          for smarter, sharper solutions. At Raiden Labs, custom platforms
          aren’t just another project; we engineer them with security,
          scalability, and user engagement as core priorities. Interfaces aren’t
          just eye candy—they’re built for real-world use and real people.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          How our Ludo game development has changed the business directly here
          from clients' experience and results, by partnering with us in their
          Ludo game development journey
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
{/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ARDevelopmentGame;
